import { useEffect, useState } from 'react';
import { InterruptionTypeAPI } from '../../../../services/external/APIs';
import { InterruptionTypeModelAPI } from '../../../../models';
import { BaseSelector } from '../../../../models/baseSelector';
import AsyncSelect from 'react-select/async';

interface Props {
    name: string;
    disable?: boolean;
    onChange: (name: string, value: string | null | number | undefined) => void;
    value: string | undefined | number;
}

export const InterruptionsByEmployeePortal = ({
    name,
    onChange,
    disable = false,
    value,
}: Props) => {
    const [dataList, setDataList] = useState<BaseSelector[]>([]);
    const [isLoadingData, setIsLoadingData] = useState(true);

    useEffect(() => {
        InterruptionTypeAPI.getInterruptionsTypeByEmployeePortal()
            .then((res) => {
                const convertedResponse = res.map(
                    (item: InterruptionTypeModelAPI) => {
                        return {
                            label: item.name,
                            value: item.id,
                        };
                    }
                );
                setDataList(convertedResponse);
            })
            .finally(() => {
                setIsLoadingData(false);
            });
    }, []);

    const filterName = (inputValue: string) => {
        return dataList.filter((i) =>
            i.label.toLowerCase().includes(inputValue.toLowerCase())
        );
    };

    const loadOptions = (
        inputValue: string,
        callback: (options: BaseSelector[]) => void
    ) => {
        setTimeout(() => {
            callback(filterName(inputValue));
        }, 1000);
    };

    return (
        <AsyncSelect
            isLoading={isLoadingData}
            onChange={(e) => {
                onChange(name, e?.value);
            }}
            required
            cacheOptions
            loadOptions={loadOptions}
            defaultOptions={dataList}
            name='interruptions-by-user-selector'
            placeholder={`Seleccione...`}
            className='flex-1'
            isDisabled={disable}
            value={
                dataList.find((a) => a.value === value) ?? {
                    label: `Seleccione...`,
                    value: 0,
                }
            }
        />
    );
};
